"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProtectingOurPlanet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.4
  });
  return <section data-section-id="236708" id="the-gallery-of-excellence" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 flex w-full h-full">
        <div className="w-1/2 h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/modern_kitchen_remodel_detail.png)] bg-cover bg-center" />
        <div className="w-1/2 h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/architectural_blueprint_overlay.png)] bg-cover bg-center" />
      </div>

      {}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-[1px]" />

      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/blueprint_watermark_texture.png)] opacity-10 mix-blend-multiply pointer-events-none" />

      {}
      <div ref={ref} className="relative z-10 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-24">
        <h2 className={`
            font-default text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] leading-[0.9] font-bold uppercase tracking-tighter
            transition-colors duration-[1500ms] ease-in-out
            ${isVisible ? "text-foreground" : "text-transparent"}
          `} style={{
        WebkitTextStroke: "1px var(--color-foreground)"
      }}>
          Gallery
          <br />
          <span className={`
              transition-colors duration-[1500ms] delay-300 ease-in-out
              ${isVisible ? "text-primary" : "text-transparent"}
            `} style={{
          WebkitTextStroke: "1px var(--color-primary)"
        }}>
            of the
          </span>
          <br />
          Excellence
        </h2>

        <p className={`
            mt-8 max-w-2xl text-lg sm:text-xl md:text-2xl text-foreground/90 font-default
            transition-all duration-1000 delay-700 ease-out
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          Precision in every joint and seam. Experience the BT philosophy of high-end craftsmanship and architectural mastery.
        </p>

        <div className={`
            mt-12
            transition-all duration-1000 delay-1000 ease-out
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          <Link to="/OurPortfolioPage">
            <Button size="lg" className="h-14 px-10 text-lg rounded-md uppercase tracking-widest font-default font-bold shadow-xl hover:scale-105 transition-transform duration-300 bg-primary text-primary-foreground">
              View Our Work
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}